module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-11.8f35c449.png";